import getAPIResponse from "./common/Common";

export async function getPlayers() {
	return await getAPIResponse("/api/v1/user/players");
}
